import { useQuery } from '@tanstack/react-query';
import { repoMarginCallService } from '@/services/trades/repo-margin-call-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';
import type { RepoMarginCallPreview } from '@/types';

/**
 * GET /repo-margin-calls/preview/ — the computed repo margin call for a counterparty's repo book, in
 * its GMRA agreement currency (`currency`). Disabled until both are known. The cash pool lives
 * server-side, so the netted net_due / cashpool_before are authoritative here
 * (the FE cannot derive them from the trade rows alone).
 */
export const useRepoMarginCallPreview = (
  counterpartyName: string | undefined,
  currency: string,
  enabled = true,
) => {
  return useQuery<RepoMarginCallPreview>({
    queryKey: tradesKeys.repoMarginCallPreview(counterpartyName ?? '', currency),
    queryFn: () => repoMarginCallService.getPreview(counterpartyName as string, currency),
    enabled: enabled && !!counterpartyName && !!currency,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
